import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import ru from "./ru.json";
import tr from "./tr.json";

/**
 * Initialize i18next with translations for each section.
 * The resources object groups translations by language and section.
 */
i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			ru: { translation: ru },
			tr: { translation: tr },
		},
		supportedLngs: ["ru", "en", "tr"],

		fallbackLng: process.env.REACT_APP_DEFAULT_LANGUAGE || "ru",
		debug: process.env.NODE_ENV === "development",
		interpolation: {
			escapeValue: false,
		},
		detection: {
			// No "navigator"/"htmlTag": a new visitor should see the
			// fallbackLng (Russian) rather than be guessed into another
			// language by their browser. An explicit choice persists via
			// localStorage/cookie and is respected on return visits.
			order: ["querystring", "localStorage", "cookie"],
			caches: ["localStorage", "cookie"],
		},
	});

export default i18n;
